import { appKey } from './index'
import { DEPLOY_ENV } from '@/defines/env'
const appKeyList = ['mall', 'small']
const _appKey = appKeyList.includes(appKey) ? appKey : 'mall'

const APP_CONFIG_MAP = {
  // 美菜商城
  mall: {
    app_name: '美菜商城',
    app_short_name: '美菜',
    freight_name: '美菜运费',
    ossUrl: 'https://img-oss.yunshanmeicai.com/',
    domain: 'yunshanmeicai.com',
    themeColor: '#15BB5C',
    themeStartColor: '#37DF7E',
    themeEndColor: '#15BB5C',
    colorClass: 'mall-color',
    bgColorClass: 'mall-bg-color',
    lightBgColorClass: 'mall-light-bg-color',
    themeActiveColor: 'mall-color-active',
    borderColorClass: 'mall-color-border'
  },
  // 小城市商城
  small: {
    app_name: '有鲜生活',
    app_short_name: '有鲜',
    freight_name: '运费',
    ossUrl: 'https://img-oss.linmontop.com.cn/',
    domain: 'linmontop.com.cn',
    themeColor: '#FF5019',
    themeStartColor: '#FF5E01',
    themeEndColor: '#FE2E31',
    colorClass: 'small-color',
    bgColorClass: 'small-bg-color',
    lightBgColorClass: 'small-light-bg-color',
    themeActiveColor: 'small-color-active',
    borderColorClass: 'small-color-border'
  }
}

export const PASSPORT_GATEWAY_ENV = {
  mall: {
    stage: 'stage',
    online: 'online'
  },
  small: {
    stage: 'smallDev',
    online: 'smallProd'
  }
}[_appKey][DEPLOY_ENV]

const MAIN_BG_MAP = {
  mall: 'https://img-oss.yunshanmeicai.com/spruce_material/45b2435abd4eb5deca1df9a6f43e1fbb',
  small:
    'https://img-oss.linmontop.com.cn/spruce_material/fd624b16e367c6e882894ca24795ecdb'
}

export const ossUrl = APP_CONFIG_MAP[_appKey].ossUrl
export const domain = APP_CONFIG_MAP[_appKey].domain

export const TRACER_FETCH_URL = {
  stage: `https://pre-logengine.${domain}/encryptLog`,
  online: `https://logengine.${domain}/encryptLog`
}[DEPLOY_ENV]

export const logoImg = require(`@/images/app/logo_${_appKey}.png`)
export const goodDefaultImg = require(`@/images/empty/good_default_${_appKey}.png`)
export const mainBgImg = MAIN_BG_MAP[_appKey]

export const tree1Img = require(`@/images/money_tree/tree/tree1_2021_${_appKey}.gif`)
export const thankTip1Img = require(`@/images/money_tree/tips/thank_2021_tip1_${_appKey}.png`)
export const thankTip2Img = require(`@/images/money_tree/tips/thank_2021_tip2_${_appKey}.png`)
export const thankTip3Img = require(`@/images/money_tree/tips/thank_2021_tip3_${_appKey}.png`)
export const thankTip4Img = require(`@/images/money_tree/tips/thank_2021_tip4_${_appKey}.png`)
export const thankTip5Img = require(`@/images/money_tree/tips/thank_2021_tip5_${_appKey}.png`)

export const loseLottery0Img = require(`@/images/redPackageRain/loseLottery/lose_lottery0_${_appKey}.png`)
export const loseLottery1Img = require(`@/images/redPackageRain/loseLottery/lose_lottery1_${_appKey}.png`)
export const loseLottery2Img = require(`@/images/redPackageRain/loseLottery/lose_lottery2_${_appKey}.png`)
export const loseLottery3Img = require(`@/images/redPackageRain/loseLottery/lose_lottery3_${_appKey}.png`)
export const loseLottery4Img = require(`@/images/redPackageRain/loseLottery/lose_lottery4_${_appKey}.png`)
export const mainTipsImg = require(`@/images/redPackageRain/main_tips_${_appKey}.png`)
export const lotteryLuckBgImg = require(`@/images/redPackageRain/lotteryLuck/bg_lottery_luck_${_appKey}.png`)
export const qrCodeImg = require(`@/images/new_good_req/qrcode_${_appKey}.png`)
export const memberOpenBg = require(`@/images/member/open_bg_${_appKey}.png`)

export const fileterAllDownImg = require(`@/images/activity_goods/all_down_active_${_appKey}.png`)
export const fileterAllUpImg = require(`@/images/activity_goods/all_up_active_${_appKey}.png`)
export const fileterDownImg = require(`@/images/activity_goods/d_${_appKey}.png`)
export const fileterActiveImg = require(`@/images/activity_goods/filter_active_${_appKey}.png`)
export const fileterUpImg = require(`@/images/activity_goods/up_${_appKey}.png`)

export const APP_CONFIG = APP_CONFIG_MAP[_appKey]

const THEME_BG_CLASS_MAP = {
  mall: {
    // eslint-disable-next-line prettier/prettier
    'mall': true
  },
  // 小城市商城
  small: {
    // eslint-disable-next-line prettier/prettier
    'small': true
  }
}

export const COLOR_CLASS = APP_CONFIG_MAP[_appKey].colorClass
export const BG_COLOR_CLASS = APP_CONFIG_MAP[_appKey].bgColorClass
export const THEME_COLOR = APP_CONFIG_MAP[_appKey].themeColor
export const THEME_START_COLOR = APP_CONFIG_MAP[_appKey].themeStartColor
export const THEME_ENG_COLOR = APP_CONFIG_MAP[_appKey].themeEndColor
export const THEME_LIGHT_BG_COLOR = APP_CONFIG_MAP[_appKey].lightBgColorClass
export const THEME_BG_CLASS = THEME_BG_CLASS_MAP[_appKey]
export const BORDER_COLOR_CLASS = APP_CONFIG_MAP[_appKey].borderColorClass
